/* eslint no-bitwise: 0 */

// from https://gist.github.com/0x263b/2bdd90886c2036a1ad5bcf06d6e6fb37

export const toHexColor = (string) => {
  let hash = 0
  if (string.length === 0) return hash
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
    hash &= hash
  }
  let color = '#'
  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 255
    color += (`00${value.toString(16)}`).substr(-2)
  }

  return color
}
